import emailjs from "@emailjs/browser";
import React, { useRef } from "react";
import "./Contact.css";
import Fade from "react-reveal";
const Contact = () => {
  const form = useRef();
  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        "service_7wv1b59",
        "template_wkui289",
        e.target,
        "vycITuKKuRbLEyMMT",
      )
      .then(
        (result) => {
          console.log(result.text);
        },
        (error) => {
          console.log(error.text);
        },
      );
    e.target.reset();
  };
  return (
    <div id="contact" className="pt-5 contact-section pb-5">
      <Fade bottom duration={2500} distance="40px">
        <h1 className="fw-bold text-white text-center pt-3">
          Ge<span className="some">t In Tou</span>ch
        </h1>
      </Fade>

      <div className="container mt-5">
        <Fade bottom duration={2500} distance="40px">
          <div className="row row-cols-lg-3 text-white text-center">
            <div className="col">
              <p className="fw-bold icon">
                <i class="fas fa-phone-alt"></i>
              </p>
              <h3 className="fs-3 fw-bold">Call Me</h3>
              <p className="fw-bold ">
                <a className="info text-white" href="tel:+8801707306482">
                  +8801707306482
                </a>
              </p>
            </div>
            <div className="col">
              <p className="fw-bold icon">
                <i class="fas fa-map-marker-alt"></i>
              </p>
              <h3 className="fs-3 fw-bold">Location</h3>
              <p className="fw-bold ">
                {" "}
                <a className="info text-white" href="#" target="_blank">
                  Uttara, Dhaka
                </a>
              </p>
            </div>
            <div className="col">
              <p className="fw-bold icon">
                <i class="fas fa-envelope"></i>
              </p>
              <h3 className="fs-3 fw-bold">Email</h3>
              <p className="fw-bold ">
                {" "}
                <a
                  className="info text-white"
                  href="mailto:mdriyadtalukder.cse@gmail.com"
                >
                  mdriyadtalukder.cse@gmail.com
                </a>
              </p>
            </div>
          </div>
        </Fade>

        <div className="row row-cols-lg-2 row-cols-md-2 row-cols-sm-1 row-cols-1 mt-5">
          <Fade left duration={2500} distance="40px">
            <div id="col1" className="col">
              <p className="info fw-bold text-white mb-4">
                I'd Love to hear from you. Whether you have a question or just
                want to say Hi, feel free to drop a message. I'll try my best to
                get back to you!
              </p>
              <form autoComplete="off" onSubmit={sendEmail}>
                <div className="row pt-3  ">
                  <div className="col-8 form-group w-100 ">
                    <input type="text" placeholder="Name" name="name" />
                  </div>
                  <div className="col-8 form-group pt-2 w-100 ">
                    <input
                      type="email"
                      placeholder="Email Address"
                      name="email"
                    />
                  </div>
                  <div className="col-8 form-group pt-2  w-100">
                    <input type="text" placeholder="Subject" name="subject" />
                  </div>
                  <div className="col-8 form-group pt-2 w-100 ">
                    <textarea
                      id=""
                      cols="30"
                      rows="8"
                      placeholder="Your message"
                      name="message"
                    ></textarea>
                  </div>
                  <div className="col-8 pt-3 w-100 ">
                    <input
                      type="submit"
                      className="btn btnn w-100 text-white fw-bold"
                      value="Send Message"
                    ></input>
                  </div>
                </div>
              </form>
            </div>
          </Fade>
          <Fade right duration={2500} distance="40px">
            <div id="col2" className="col">
              <img
                id="imggg"
                src="https://www.myassignmentservices.ae/assets/front/images/contactPg.svg"
                className="img-fluid pt-5"
                alt=""
              />
            </div>
          </Fade>
        </div>
      </div>
    </div>
  );
};

export default Contact;
